import { Paper } from '@mui/material';
import React from 'react';
import { Page } from '../../components/Page/Page.tsx';

export const MarketingConsent = () => {
    return (
        <Page title="Zgoda marketingowa" theme="light">
            <Paper className="lessons__paper paper">
                <div className="singleLesson__wrapper">
                    <h1>Tu pojawi sie treść zgody marketingowej</h1>
                </div>
            </Paper>
        </Page>
    );
};
